import type { ColDef, ValueFormatterParams, ValueGetterParams } from 'ag-grid-community';

import { formatDate } from '~/utils/date';

import { DATE_FORMAT } from '~/constants';

import type { TypeDeliveryAgencyOutboundUnitListItem } from '~/types/delivery-agency.types';

const getDeliveryAgencyOutboundUnitListColumnDefs = ({
  currentPage,
  pageSize,
}: {
  currentPage: number;
  pageSize: number;
}) => {
  const columnDefs: ColDef<TypeDeliveryAgencyOutboundUnitListItem>[] = [
    {
      headerName: 'No',
      valueGetter: ({ node }) => (node?.rowIndex ?? 0) + 1 + currentPage * pageSize,
      width: 96,
      headerCheckboxSelection: true,
      checkboxSelection: true,
    },
    {
      field: 'estimatedDeliveryDate',
      headerName: '배송 예정일',
      width: 100,
      valueFormatter: ({
        value,
      }: ValueFormatterParams<
        TypeDeliveryAgencyOutboundUnitListItem,
        TypeDeliveryAgencyOutboundUnitListItem['estimatedDeliveryDate']
      >) => formatDate(value, DATE_FORMAT.DATE) ?? '-',
    },
    {
      field: 'outboundCode',
      headerName: '출고번호',
      width: 160,
    },
    {
      field: 'isOutboundUnitConfigurable',
      headerName: '합포 단위 설정 가능',
      width: 160,
      valueGetter: ({
        data,
      }: ValueGetterParams<
        TypeDeliveryAgencyOutboundUnitListItem,
        TypeDeliveryAgencyOutboundUnitListItem['isOutboundUnitConfigurable']
      >) => {
        if (!data) return '-';
        return data.isOutboundUnitConfigurable ? '설정 가능' : '설정 불가';
      },
    },
    {
      field: 'clientOrderCodes',
      headerName: '판매처 주문번호',
      minWidth: 160,
      flex: 1,
      valueFormatter: ({
        value,
      }: ValueFormatterParams<
        TypeDeliveryAgencyOutboundUnitListItem,
        TypeDeliveryAgencyOutboundUnitListItem['clientOrderCodes']
      >) => (value?.length ? value.join(', ') : '-'),
    },
    {
      field: 'shippingLabels',
      headerName: '운송장 번호',
      minWidth: 160,
      flex: 1,
      valueFormatter: ({
        value,
      }: ValueFormatterParams<
        TypeDeliveryAgencyOutboundUnitListItem,
        TypeDeliveryAgencyOutboundUnitListItem['shippingLabels']
      >) => value?.join(', ') ?? '-',
    },
    {
      field: 'ordererName',
      headerName: '주문자명',
      width: 100,
    },
    {
      field: 'receiverName',
      headerName: '수령자명',
      width: 100,
    },
    {
      field: 'deliveryType.description',
      headerName: '배송 유형',
      width: 80,
    },
    {
      field: 'courierCodeCode.description',
      headerName: '배송사',
      width: 88,
    },
  ];

  return { columnDefs };
};

export default getDeliveryAgencyOutboundUnitListColumnDefs;
